<template>
  <div id="events-view">
    <div class="d-flex justify-content-between align-items-center title-block border-bottom ml-3">
      <PageTitleComponent pageTitle="Events" category="Werbeinhalte" categoryIcon="ad" />
      <CreateEventComponent />
    </div>
    <div class="pl-3 py-3">
      <div class="mt-2 alert alert-warning" v-if="events === null">Hier gibt es noch nichts zu sehen. Klicke auf "Erstellen" um das zu ändern. 😉</div>
      <b-tabs v-else-if="Object.keys(events).length > 0">
        <b-tab title="Aktuell" active v-if="Object.keys(activeEventsSorted).length > 0">
          <table class="table mt-3">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Typ</th>
                <th>Tabelle</th>
                <th>Datum</th>
                <th>Sprache</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <EventRowComponent v-for="(item, key) in activeEventsSorted" :key="`event-${key}`" :item="item" :itemKey="key" v-on:selectedItem="selectItem" />
              <tr v-if="Object.keys(activeEventsSorted).length === 0">
                  <td colspan="6">
                    keine Daten vorhanden
                  </td>
                </tr>
            </tbody>
          </table>
        </b-tab>
        <b-tab title="Abgelaufen">
          <table class="table mt-3">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Typ</th>
                <th>Tabelle</th>
                <th>Datum</th>
                <th>Sprache</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <EventRowComponent v-for="(item, key) in inactiveEventsSorted" :key="`event-${key}`" :item="item" :itemKey="key" v-on:selectedItem="selectItem" />
              <tr v-if="Object.keys(inactiveEventsSorted).length === 0">
                <td colspan="6">
                  keine Daten vorhanden
                </td>
              </tr>
            </tbody>
          </table>
        </b-tab>
      </b-tabs>
      <SpinnerComponent class="mt-3" v-else />
    </div>
    <EditEventComponent 
      :modalId="'edit-event-modal'" 
      :selectedKey="selectedKey" 
      :selectedItem="selectedItem" />
  </div>
</template>

<script>
import PageTitleComponent from '../components/PageTitleComponent'
import CreateEventComponent from '../components/CreateEventComponent'
import EditEventComponent from '../components/EditEventComponent'
import EventRowComponent from '../components/EventRowComponent'
import SpinnerComponent from '../components/SpinnerComponent'
import _ from 'lodash'
import moment from 'moment-timezone'

import { db } from "../plugins/firebase"
import { onValue, ref } from "firebase/database"

export default {
  name: 'EventsView',
  components: {
    PageTitleComponent,
    CreateEventComponent,
    EditEventComponent,
    EventRowComponent,
    SpinnerComponent
  },
  methods: {
    selectItem: function(data) {
      this.selectedKey = data.key
      this.selectedItem = data.item
      this.$bvModal.show('edit-event-modal')
    }
  },
  computed: {
    activeEventsSorted: function() {
      const events = Object.entries(this.events).filter(([key, item]) => {
        const nowTimestamp = moment(moment().tz('Europe/Berlin').format('YYYY-MM-DD')).unix()
        const dateTimestamp = moment(item.date).unix()

        if (dateTimestamp >= nowTimestamp) {
          return [key, item]
        }  
      })

      const eventsSorted = _.orderBy(events, [(item) => {
        return moment(item[1].date)
      }], ['asc'])

      return Object.fromEntries(eventsSorted)
    },
    inactiveEventsSorted: function() {
      const events = Object.entries(this.events).filter(([key, item]) => {
        const nowTimestamp = moment(moment().tz('Europe/Berlin').format('YYYY-MM-DD')).unix()
        const dateTimestamp = moment(item.date).unix()

        if (dateTimestamp < nowTimestamp) {
          return [key, item]
        }  
      })

      const eventsSorted = _.orderBy(events, [(item) => {
        return moment(item[1].date)
      }], ['desc'])

      return Object.fromEntries(eventsSorted)
    }
  },
  mounted() {
    onValue(ref(db ,'events'), snapshot => {
      this.events = snapshot.val()
    })
  },
  data() {
    return {
      events: [],
      selectedKey: '',
      selectedItem: {}
    }
  }
}
</script>

<style scoped>
#events-view {
  margin-left: 250px;
}
.title-block {
  height: 120px;
}
</style>